import _isEmpty from 'lodash/isEmpty';

/**
 * Checks if an option includes a specific non-visualization tag.
 * Currently used by Builders + Rack Systems
 *
 * @param {Object} option - The option object to check
 * @param {string} option.tags - Array of tags associated with the option
 * @param {string} tag - The specific tag to search for
 * @returns {boolean} Returns true if the option contains the specified tag, false otherwise
 * @example
 * const option = { tags: ['layout', 'design'] };
 * const hasLayoutTag = optionIncludesNonViz(option, 'layout'); // returns true
 */
export const optionIncludesNonViz = (option, tag) => {
  if (_isEmpty(option.tags)) return false;

  return option.tags.includes(tag);
};
